/**
 * Region derivation from a SoW number. Lives in @eip/shared so the client picker
 * and the server-side deadline fallback derive region from the SAME source (the
 * SoW number), preventing the divergence where the client used the SoW number and
 * the server used founder.userRegion (R6).
 *
 * SoW number format: EIP{regionCode}SoWT{tier}{seq}
 * e.g. "EIPNFSoWT31009" → "NF" → "northForge".
 */
const REVERSE_REGION_CODES: Record<string, string> = {
  CT: "communitech",
  NF: "northForge",
  IO: "investOttawa",
  LL: "launchLab",
  SC: "sparkCenter",
};

export function extractRegionFromSowNumber(
  sowNumber: string | undefined | null
): string | null {
  if (!sowNumber || sowNumber.length < 5) return null;
  const code = sowNumber.substring(3, 5);
  return REVERSE_REGION_CODES[code] || null;
}
